export default __webpack_public_path__ + "static/media/tm.c1f482ee.svg";